export default "__VITE_ASSET__4M766JN7__"